import React, { useState, useEffect } from "react";
import styles from "./AutomateCreateIn.module.css";
import HeaderFormsComponent from "../../../HeadersFormsComponent/HeaderFormsComponent";
import SelectLocation from "../../../SelectLocation/SelectLocation";
import { useDispatch, useSelector } from "react-redux";

import EditableInput from "../FileInput/Input";
// import EditableInput from '../../AccountSettings/EditableInput/EditableInput';

import FileInputNotification from "../FileInput/Notification";
import FileInputImport from "../FileInput/Import";
import SelectInfoToProcess from "../FileInput/selectInfoToProcces/SelectInfoToProcess";
import { promptAutomate } from "@src/actions/automate";
import {
  cleanTryConnectionAutomate,
  setAutomateNameTitleIn,
  setSelectedEmailConnection,
} from "../../../../../../slices/automateSlices";

import ModalAddConnection from "../ModalsAddConnection/ModalAddConnection";

import { ReactComponent as IconMagic } from "../../../../assets/icon-magic.svg";
import { ReactComponent as Gmail } from "../../../../assets/gmailCircle.svg";
import { ReactComponent as GmailEnG } from "../../../../assets/GmailEnG.svg";
import { ReactComponent as MicrosoftLogo } from "../../../../assets/MicrosoftLogo.svg";
import { ReactComponent as CircleOutlook } from "../../../../assets/outlookCircle.svg";
import { ReactComponent as EmailGray } from "../../../../assets/EmailGray.svg";
import { ReactComponent as GoogleDrive } from "../../../../assets/driveCircle.svg";
import { ReactComponent as DropBox } from "../../../../assets/dropboxCircle.svg";
import { ReactComponent as OneDrive } from "../../../../assets/oneDriveCircle.svg";
import { ReactComponent as GmailIcon } from "../../../../assets/gmailwithoutbg.svg";
import { ReactComponent as OutlookIcon } from "../../../../assets/outlook.svg";
import { ReactComponent as EmailIcon } from "../../../../assets/email.svg";
import { ReactComponent as DriveIcon } from "../../../../assets/driveCircle.svg";
import { ReactComponent as DropboxIcon } from "../../../../assets/dropbox-icon.svg";
import { ReactComponent as WhatsAppIcon } from "../../../../assets/whatsappIcon.svg";
import { ReactComponent as SharepointIcon } from "../../../../assets/sharePointCircle.svg";
import { ReactComponent as OneDriveIcon } from "../../../../assets/oneDriveCircle.svg";
import AttachmentNotification from "../AttachmentNotification/AttachmentNotification";
import { useTranslation } from "react-i18next";
import FilterInfoDateKey from "../FilterInfoDateKey/FilterInfoDateKey";
import StatsAutomate from "../StatsAutomate/StatsAutomate";
import ChatAutomate from "./ChatAutomate/ChatAutomate";

const AutomateCreateIn = ({
  type,
  configuration,
  setConfiguration,
  setShowCategory,
  formAutomateContainerRef,
  iconType,
  IconHeaderModAddConnection,
  typeVariableModal,
  setTypeVariableModal,
  showVariableListModal,
  setShowVariableListModal,
  showVariableModal,
  setShowVariableModal,
  // setQuestion,
  selectedAgent,
  toggleChatSettings,
  setToggleChatSettings
}) => {
  const dispatch = useDispatch();
  const [t] = useTranslation("AutomatesComponent");
  const [showAddConnection, setShowAddConnection] = useState(false);
  const [authData, setAuthData] = useState([]);
  const [authOutlook, setAuthOutlook] = useState([]);
  const [authDrive, setAuthDrive] = useState([]);
  const [userDevices, setUserDevices] = useState([]);
  const [authOneDrive, setAuthOneDrive] = useState([]);

  const iconComponents = {
    "Gmail": <GmailIcon/>,
    "Outlook": <OutlookIcon/>,
    "SMTP": <EmailIcon/>,
    "Google Drive": <DriveIcon/>,
    "Dropbox": <DropboxIcon/>,
    "WhatsApp": <WhatsAppIcon/>,
    "Sharepoint": <SharepointIcon/>,
    "One Drive": <OneDriveIcon/>,
  };
  
  console.log('configurationconfigurationconfiguration',configuration)

  const [showSelectOutputLocation, setShowSelectOutputLocation] =
    useState(false);

  const [showOutlookModalAddConnection, setShowOutlookModalAddConnection] =
    useState(false);

  const { automate } = useSelector((state) => state);
  const [showGmailModalAddConnection, setShowGmailModalAddConnection] =
    useState(false);



    const handleConfigurationChange = (field, value, index = null, filterIndex = null) => {
      setConfiguration(prev => {
        const updatedLabels = Array.isArray(prev.labels) ? [...prev.labels] : [];
    
        if (index !== null && updatedLabels[index]) {
          const label = { ...updatedLabels[index] };
    
          if (filterIndex !== null && Array.isArray(label.filters)) {
            const updatedFilters = [...label.filters];
            const filter = { ...updatedFilters[filterIndex] };
    
            // ✅ Soporte toggle para 'variables' en filtros
            if (field === "variables") {
              const currentArray = Array.isArray(filter.variables) ? [...filter.variables] : [];
              const exists = currentArray.some(v => v._id === value._id);
    
              filter.variables = exists
                ? currentArray.filter(v => v._id !== value._id)
                : [...currentArray, value];
            } else {
              // Resto de campos normales en filtros
              filter[field] = value;
            }
    
            updatedFilters[filterIndex] = filter;
            label.filters = updatedFilters;
          }
          // ✅ Soporte original para campos directos en label
          else if (["plainTextLabels", "labels", "variables"].includes(field)) {
            label[field] = value;
          }
    
          updatedLabels[index] = label;
    
          return {
            ...prev,
            labels: updatedLabels
          };
        }
    
        // ✅ Fallback global
        return {
          ...prev,
          [field]: value
        };
      });
    };
    
  const OutlookAddConnection = (connection) => {
    const updatedConnections = [
      ...(configuration?.emailConnectionData || []),
      connection,
    ];
    handleConfigurationChange("emailConnectionData", updatedConnections);
    if (!configuration?.selectedEmailConnection) {
      handleConfigurationChange("selectedEmailConnection", connection.email);
    }
  };

  const defaultAddConnection = (connection) => {
    const updatedConnections = [
      ...(configuration?.defaultConnectionData || []),
      connection,
    ];
    handleConfigurationChange("defaultConnectionData", updatedConnections);
    if (!configuration?.selectedDefaultConnection) {
      handleConfigurationChange(
        "selectedDefaultConnection",
        connection.clientId
      );
    }
  };

  useEffect(() => {
    if (configuration.selectedEmailConnection) {
      dispatch(
        setSelectedEmailConnection(configuration.selectedEmailConnection || "")
      );
    }
    return () => {
      dispatch(setSelectedEmailConnection(""));
    };
  }, [configuration.selectedEmailConnection]);

  useEffect(() => {

    return () => {
      dispatch(cleanTryConnectionAutomate());
    };
  }, []);

  useEffect(() => {
    if (type === "Gmail") {
      if (automate.authData) {
        setAuthData(automate.authData);
      }
    } else if (type === "Outlook") {
      if (automate.authOutlook?.success) {
        const constructorEqualAuthData = automate.authOutlook?.data?.map(
          (ele) => {
            return {
              email: ele.account?.mail,
              userId: ele.userId,
              type: type,
              id: ele._id,
            };
          }
        );
        setAuthOutlook(constructorEqualAuthData);
      }
    } else if (type === "Google Drive") {
      if (automate.authDrive?.success) {
        const constructorEqualAuthData = automate.authDrive?.data?.map(
          (ele) => {
            return {
              email: ele.email,
              userId: ele.userId,
              type: type,
              id: ele._id,
            };
          }
        );
        setAuthDrive(constructorEqualAuthData);
      }
    } else if (type === "WhatsApp") {
      if (automate.userDevices?.success) {
        const devices = automate.userDevices?.devices.map((ele) => {
          return {
            email: ele.deviceId,
            userId: ele.userId,
            type: ele.type,
            id: ele.id,
          };
        });
        setUserDevices(devices);
      }
    } else if (type === "One Drive") {
      if (automate.authOneDrive?.success) {

        const constructorEqualAuthDataOneDrive = automate.authOneDrive?.data?.map(
          (ele) => {
            return {
              email: ele.account?.mail,
              userId: ele.userId,
              type: type,
              id: ele._id,
            };
          }
        );
        setAuthOneDrive(constructorEqualAuthDataOneDrive);
      }
    } else {
      setAuthData([]);
      setAuthOutlook([]);
      setUserDevices([]);
    }
  }, [
    automate.authData,
    automate.authOutlook?.success,
    automate.authDrive?.data,
    automate.userDevices,
    type,
  ]);
  useEffect(() => {
    if (configuration.id) {
      dispatch(setAutomateNameTitleIn(`${t("modifyYourInvoices")} ${type}`));
    } else {
      dispatch(setAutomateNameTitleIn(`${t("addYourInvoices")} ${type}`));
    }
  }, [type, configuration.id]);

  const handleModalAddConnection = (modalType) => {
    if (modalType === "Gmail") {
      setShowGmailModalAddConnection(true);
    } else if (modalType === "Outlook") {
      setShowOutlookModalAddConnection(true);
    }
  };


  const handlePromptAutomateAI = async () => {
    console.log('456543456')
    const response = await dispatch(promptAutomate({
      prompt: configuration.inputValue,
    }))

    console.log('response', response)

    if (response.payload && response.payload.success) {
      console.log('configuration', configuration)

      setConfiguration({
        ...configuration,
        ...response.payload.data,
        showContentFilterInfoDateKey: {
          info9: true,
        },
        showContentSelectInfoToProcess: {
          info9: true,
        },
        showContentImport: {
          info1: true,
        },
        showContentCustomNotify: {
          info4: true
        },
        actionExtractionFrequency: true,
        // allowAllFileTypes: true,
      })
      // setConfiguration


      // handleConfigurationChange("title", response.payload.data.title)
      // handleConfigurationChange("description", response.payload.data.description)
      // handleConfigurationChange("value", response.payload.data.value)
    }
  }


  const [isOpenAutomate, setIsOpenAutomate] = useState(false);


  return (
    <div style={{
      height: toggleChatSettings == 'chat' &&'90%',
    }}>
      {automate.tryConnectionAutomate.success && (
        <AttachmentNotification
          attachments={automate.tryConnectionAutomate.data}
          type={type}
          automationId={configuration.id}
        />
      )}
      <HeaderFormsComponent
        selectedEmailConnection={
          configuration?.selectedEmailConnection?.email || ""
        }
        setToggleChatSettings={setToggleChatSettings}
        toggleChatSettings={toggleChatSettings}
        setSelectedEmailConnection={(value) =>
          handleConfigurationChange("selectedEmailConnection", value)
        }
        emailConnections={
          type === "Gmail"
            ? authData
            : type === "Outlook"
              ? authOutlook
              : type === "Google Drive"
                ? authDrive
                : type === "WhatsApp"
                  ? userDevices
                  : type === "One Drive"
                    ? authOneDrive
                    : []
        }
        action={() => {
          if (type === "WhatsApp") {
            setShowCategory("qr");
          } else {
            setShowAddConnection(true);
          }
        }}
        icon={iconComponents[type]}
        handleConfigurationChange={handleConfigurationChange}
        placeholder={
          authData?.length > 0 || authOutlook?.length > 0
            ? t("selectAnAccount")
            : t("notYetAdded")
        }
        type={type}
        CustomDropdownOptionStyles={{
          maxWidth: "250px",
          width: "unset",
        }}
        setIsOpenAutomate={setIsOpenAutomate}
        isOpenAutomate={isOpenAutomate}
      />
      {toggleChatSettings  == 'setting' ? (
      <div className={styles.automateContainer}>

        <StatsAutomate/>

        <div className={styles.inputContainer}>
          {/* <EditableInput
            isTextarea={true}
            configuration={configuration}
            handleConfigurationChange={handleConfigurationChange}
            formAutomateContainerRef={formAutomateContainerRef}
            limit={500}
            showLimit={true}
            editable={true}
            placeholder={'Inserta el titulo de la automatización'}
          /> */}
          {configuration?.inputValue?.split(' ').length > 3 && (
            <button
              className={styles.iconMagic}
              onClick={handlePromptAutomateAI}>
              <IconMagic />
            </button>
          )}
        </div>




        <FilterInfoDateKey
          configuration={configuration}
          handleConfigurationChange={handleConfigurationChange}
          formAutomateContainerRef={formAutomateContainerRef}
          type={type}
        />

        <SelectInfoToProcess
          configuration={configuration}
          handleConfigurationChange={handleConfigurationChange}
          setShowSelectOutputLocation={setShowSelectOutputLocation}
          formAutomateContainerRef={formAutomateContainerRef}
          type={type}
          setShowVariableModal={setShowVariableModal}
          setTypeVariableModal={setTypeVariableModal}
        />

        <FileInputImport
          configuration={configuration}
          handleConfigurationChange={handleConfigurationChange}
          setShowSelectOutputLocation={setShowSelectOutputLocation}
          setShowCategory={setShowCategory}
          formAutomateContainerRef={formAutomateContainerRef}
          typeVariableModal={typeVariableModal}
          setTypeVariableModal={setTypeVariableModal}
          showVariableListModal={showVariableListModal}
          setShowVariableListModal={setShowVariableListModal}
          showVariableModal={showVariableModal}
          setShowVariableModal={setShowVariableModal}

        />

        <FileInputNotification
          configuration={configuration}
          handleConfigurationChange={handleConfigurationChange}
          formAutomateContainerRef={formAutomateContainerRef}
          setShowCategory={setShowCategory}
          setShowGmailModalAddConnection={handleModalAddConnection}
        />
      </div>
      ) : (
        <ChatAutomate type={type} configuration={configuration}/>
      )}

      {showSelectOutputLocation && (
        <SelectLocation
          onClose={() => setShowSelectOutputLocation(false)}
          pickLocation={(location) => {
            handleConfigurationChange("folderLocation", location);
          }}
          emailListColab={(emailListColab) => {
            handleConfigurationChange("emailListColab", emailListColab);
          }}
          configuration={configuration}
        />
      )}
      {showAddConnection &&
        (() => {
          switch (type) {
            case "Gmail":
              return (
                <ModalAddConnection
                  type={type}
                  IconHeader={Gmail}
                  IconLogin={GmailEnG}
                  textLogin={t("signinWithGoogle")}
                  close={() => setShowAddConnection(false)}
                  // setQuestion={setQuestion}
                  selectedAgent={selectedAgent}
                />
              );
            case "SMTP":
              return (
                <ModalAddConnection
                  type={type}
                  IconHeader={CircleOutlook}
                  close={() => setShowAddConnection(false)}
                  addType={t("imapSmtp")}
                  // setQuestion={setQuestion}
                  selectedAgent={selectedAgent}
                />
              );
            case "Outlook":
              return (
                <ModalAddConnection
                  type={type}
                  IconHeader={CircleOutlook}
                  IconLogin={MicrosoftLogo}
                  textLogin={t("signinWithMicrosoft")}
                  IconLogin2={EmailGray}
                  TextLogin2={t("emailConnectionImapSmtp")}
                  close={() => setShowAddConnection(false)}
                  addType={t("imapSmtp")}
                  // setQuestion={setQuestion}
                  selectedAgent={selectedAgent}
                />
              );
            case "One Drive":
              return (
                <ModalAddConnection
                  type={type}
                  IconHeader={OneDrive}
                  IconLogin={MicrosoftLogo}
                  textLogin={t("signinWithMicrosoft")}
                  close={() => setShowAddConnection(false)}
                  addType={t("imapSmtp")}
                  // setQuestion={setQuestion}
                  selectedAgent={selectedAgent}
                />
              );
            case "Google Drive":
              return (
                <ModalAddConnection
                  type={type}
                  IconHeader={GoogleDrive}
                  IconLogin={GoogleDrive}
                  textLogin={t("signinWithGoogleDrive")}
                  close={() => setShowAddConnection(false)}
                  // setQuestion={setQuestion}
                  selectedAgent={selectedAgent}
                />
              );
            case "Dropbox":
              return (
                <ModalAddConnection
                  type={type}
                  IconHeader={DropBox}
                  textLogin={t("signinWithDropbox")}
                  close={() => setShowAddConnection(false)}
                  // setQuestion={setQuestion}
                  selectedAgent={selectedAgent}
                />
              );
            default:
              return (
                <ModalAddConnection
                  type={type}
                  IconHeader={IconHeaderModAddConnection}
                  textLogin={t("signinWithDropbox")}
                  close={() => setShowAddConnection(false)}
                  // setQuestion={setQuestion}
                  selectedAgent={selectedAgent}
                />
              );
          }
        })()}

      {showGmailModalAddConnection && (
        <ModalAddConnection
          type={"Gmail"}
          IconHeader={Gmail}
          IconLogin={GmailEnG}
          textLogin={t("signinWithGoogle")}
          close={() => setShowGmailModalAddConnection(false)}
          // setQuestion={setQuestion}
          selectedAgent={selectedAgent}
        />
      )}
      {showOutlookModalAddConnection && (
        <ModalAddConnection
          type={"Outlook"}
          IconHeader={CircleOutlook}
          IconLogin={MicrosoftLogo}
          textLogin={t("signinWithMicrosoft")}
          IconLogin2={EmailGray}
          TextLogin2={t("emailConnectionImapSmtp")}
          close={() => setShowOutlookModalAddConnection(false)}
          addType={t("imapSmtp")}
          // setQuestion={setQuestion}
          selectedAgent={selectedAgent}
        />
      )}
    </div>
  );
};

export default AutomateCreateIn;
